import React from 'react'
import { useState } from 'react'

const SimulationForm = ({simulationSubmit}) => {
    const [NHandS, setNHandS] = useState("")
    const [WHandS, setWHandS] = useState("")
    const [EHandS, setEHandS] = useState("")
    const [SHandS, setSHandS] = useState("")

    const [NHandH, setNHandH] = useState("")
    const [WHandH, setWHandH] = useState("")
    const [EHandH, setEHandH] = useState("")
    const [SHandH, setSHandH] = useState("")
    
    const [NHandD, setNHandD] = useState("")
    const [WHandD, setWHandD] = useState("")
    const [EHandD, setEHandD] = useState("")
    const [SHandD, setSHandD] = useState("")
    
    const [NHandC, setNHandC] = useState("")
    const [WHandC, setWHandC] = useState("")
    const [EHandC, setEHandC] = useState("")
    const [SHandC, setSHandC] = useState("")
    
    const [NCond, setNCond] = useState("")
    const [WCond, setWCond] = useState("")
    const [ECond, setECond] = useState("")
    const [SCond, setSCond] = useState("")

    const submitSim = (e) => {
        e.preventDefault()
        const NHand = NHandS + "."+NHandH + "."+NHandD + "."+NHandC

        simulationSubmit(NHand)
    }

    return (
        <section className="bg-indigo-50">
        <div className="container m-auto max-w-2xl py-24">
          <div
            className="bg-white px-6 py-8 mb-4 shadow-md rounded-md border m-4 md:m-0"
          >
            <form onSubmit={submitSim}>
              <h2 className="text-3xl text-center font-semibold mb-6">Wprowadź dane do symulacji</h2>
    
              <div className="mb-4">
                <label htmlFor="name1" className="block text-gray-700 font-bold mb-2"
                  >Ręka N</label
                >
                <input
                  type = "text"
                  id="NHandS"
                  name="NHandS"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {NHandS}
                  onChange={(e)=>setNHandS(e.target.value)}
                 />
                 <input
                  type = "text"
                  id="NHandS"
                  name="NHandS"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {NHandH}
                  onChange={(e)=>setNHandH(e.target.value)}
                 />
                <input
                  type = "text"
                  id="NHandD"
                  name="NHandD"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {NHandD}
                  onChange={(e)=>setNHandD(e.target.value)}
                 />
                <input
                  type = "text"
                  id="NHandC"
                  name="NHandC"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {NHandC}
                  onChange={(e)=>setNHandC(e.target.value)}
                 />
              </div>
              <div className="mb-4">
                <label htmlFor="name1" className="block text-gray-700 font-bold mb-2"
                  >Ręka E</label
                >
                <input
                  type = "text"
                  id="EHandS"
                  name="EHandS"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {EHandS}
                  onChange={(e)=>setEHandS(e.target.value)}
                 />
                 <input
                  type = "text"
                  id="EHandS"
                  name="EHandS"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {EHandH}
                  onChange={(e)=>setEHandH(e.target.value)}
                 />
                <input
                  type = "text"
                  id="EHandD"
                  name="EHandD"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {EHandD}
                  onChange={(e)=>setEHandD(e.target.value)}
                 />
                <input
                  type = "text"
                  id="EHandC"
                  name="EHandC"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {EHandC}
                  onChange={(e)=>setEHandC(e.target.value)}
                 />
              </div>
              <div className="mb-4">
                <label htmlFor="name1" className="block text-gray-700 font-bold mb-2"
                  >Ręka S</label
                >
                <input
                  type = "text"
                  id="SHandS"
                  name="SHandS"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {SHandS}
                  onChange={(e)=>setSHandS(e.target.value)}
                 />
                 <input
                  type = "text"
                  id="SHandS"
                  name="SHandS"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {SHandH}
                  onChange={(e)=>setSHandH(e.target.value)}
                 />
                <input
                  type = "text"
                  id="SHandD"
                  name="SHandD"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {SHandD}
                  onChange={(e)=>setSHandD(e.target.value)}
                 />
                <input
                  type = "text"
                  id="SHandC"
                  name="SHandC"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {SHandC}
                  onChange={(e)=>setSHandC(e.target.value)}
                 />
              </div>
              <div className="mb-4">
                <label htmlFor="name1" className="block text-gray-700 font-bold mb-2"
                  >Ręka W</label
                >
                <input
                  type = "text"
                  id="WHandS"
                  name="WHandS"
                  size = "8"
                  className="border rounded  py-2 px-3"
                  value = {WHandS}
                  onChange={(e)=>setWHandS(e.target.value)}
                 />
                 <input
                  type = "text"
                  id="WHandS"
                  name="WHandS"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {WHandH}
                  onChange={(e)=>setWHandH(e.target.value)}
                 />
                <input
                  type = "text"
                  id="WHandD"
                  name="WHandD"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {WHandD}
                  onChange={(e)=>setWHandD(e.target.value)}
                 />
                <input
                  type = "text"
                  id="WHandC"
                  name="WHandC"
                  size = "8"
                  className="border rounded py-2 px-3"
                  value = {WHandC}
                  onChange={(e)=>setWHandC(e.target.value)}
                 />
              </div>
              <div>
              <button
                className="bg-indigo-500 hover:bg-indigo-600 text-white font-bold py-2 px-4 rounded-full w-full focus:outline-none focus:shadow-outline"
                type="submit"
              >
                Przelicz symulacje              
                </button>
              </div>
            </form>
          </div>
        </div>
        </section>
    )
}



export default SimulationForm